// Default exchange rates
import { setSharedFx } from './budget.js';

export const initFX = {
  EUR: {
    gbp: 0.855,
    usd: 1.09
  },
  CHF: {
    gbp: 0.89,
    usd: 1.12
  },
  USD: {
    gbp: 0.7874,
    usd: 1.00
  },
  GBP: {
    gbp: 1.00,
    usd: 1.27
  },
  AED: {
    gbp: 0.2143,
    usd: 0.2722
  },
  SGD: {
    gbp: 0.5906,
    usd: 0.75
  },
  JPY: {
    gbp: 0.0053,
    usd: 0.0067
  },
  HKD: {
    gbp: 0.1008,
    usd: 0.128
  },
  PLN: {
    gbp: 0.197,
    usd: 0.25
  },
  SEK: {
    gbp: 0.074,
    usd: 0.094
  },
  NOK: {
    gbp: 0.072,
    usd: 0.0915
  },
  DKK: {
    gbp: 0.1145,
    usd: 0.1455
  },
  CAD: {
    gbp: 0.587,
    usd: 0.745
  },
  AUD: {
    gbp: 0.504,
    usd: 0.64
  }
};
setSharedFx(initFX);
